import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const fakeCursorForToolbarPluginKey: PluginKey = new PluginKey('fakeCursorToolbarPlugin');
